import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BgColorsOutlinedSvg from "@ant-design/icons-svg/es/asn/BgColorsOutlined";
import AntdIcon from '../components/AntdIcon';
var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BgColorsOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BgColorsOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BgColorsOutlined';
}
export default RefIcon;